export function getValueAtPath(rootObject, path) {
  return (Array.isArray(path) ? path : path.split('.')).reduce(
    (parent, key) => (parent && parent[key] ? parent[key] : null),
    rootObject
  )
}
